import { InMemoryCacheConfig } from '@apollo/client';
import merge from 'lodash/merge';
import CAPARfqReviewCache from './CAPARfqReviewCache';
import fetchQuotationUserGNBCache from './fetchQuotationUserGNBCache';
import fetchQuotationUserRfqsCache from './fetchQuotationUserRfqsCache';
import fetchQuotationUserChatRoomsCache from './fetchQuotationUserChatRoomsCache';
import CAPAQuotationUserRfqDetailOutputCache from './CAPAQuotationUserRfqDetailOutputCache';
import CAPAQuotationRfqPurchaseOrdersOutputCache from './CAPAQuotationRfqPurchaseOrdersOutputCache';
import fetchMyQuotationUser from './fetchMyQuotationUser';

const cache: InMemoryCacheConfig = {
  typePolicies: merge(
    {},
    CAPARfqReviewCache,
    fetchMyQuotationUser,
    fetchQuotationUserGNBCache,
    fetchQuotationUserRfqsCache,
    fetchQuotationUserChatRoomsCache,
    CAPAQuotationUserRfqDetailOutputCache,
    CAPAQuotationRfqPurchaseOrdersOutputCache
  )
};

export default cache;

export * from './fetchQuotationUserChatRoomsCache';
